module.exports = __webpack_public_path__ + "img/igp.7b8eec50.svg";